/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Soft_Fox_JumpInputs */

const en_wide_soft_fox_jump = /** @type {(inputs: Wide_Soft_Fox_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Width`)
};

const de_wide_soft_fox_jump = /** @type {(inputs: Wide_Soft_Fox_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breite`)
};

/**
* | output |
* | --- |
* | "Width" |
*
* @param {Wide_Soft_Fox_JumpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_soft_fox_jump = /** @type {((inputs?: Wide_Soft_Fox_JumpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Soft_Fox_JumpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_soft_fox_jump(inputs)
	return de_wide_soft_fox_jump(inputs)
});